module.exports = __webpack_public_path__ + "img/icon_parking.1dc0fb15.png";